import { SpinnerGapIcon } from '@phosphor-icons/react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import z from 'zod';

import { postSignInRedirectStorageKey } from '@constants/auth.constant';
import { resolvePostSignInRedirect } from '@helpers/authRedirect.helper';

const redirectingSearchSchema = z.looseObject({
  error: z.string().optional(),
  error_description: z.string().optional(),
});

// Hosted UI callback (VITE_VOICE_AGENT_OAUTH_REDIRECT_SIGN_IN). Amplify
// exchanges the code before the root route reads the session.
export const Route = createFileRoute('/redirecting')({
  // validateSearch must precede beforeLoad for search type inference.
  validateSearch: search => redirectingSearchSchema.parse(search),
  beforeLoad: ({ context, search }) => {
    if (search.error) {
      throw unauthorizedRedirect({
        error: search.error,
        errorDescription: search.error_description,
      });
    }

    if (!context.auth.isAuthenticated) {
      throw unauthorizedRedirect({});
    }

    throw successRedirect();
  },
  component: Redirecting,
});

function Redirecting() {
  return (
    <main className="grid min-h-dvh place-items-center">
      <SpinnerGapIcon className="text-primary size-20 animate-spin" />
    </main>
  );
}

function successRedirect() {
  const target = resolvePostSignInRedirect(
    globalThis.sessionStorage.getItem(postSignInRedirectStorageKey),
  );

  globalThis.sessionStorage.removeItem(postSignInRedirectStorageKey);

  return redirect({ href: target, replace: true });
}

type UnauthorizedRedirectInput = {
  error?: string;
  errorDescription?: string;
};

function unauthorizedRedirect({
  error,
  errorDescription,
}: UnauthorizedRedirectInput) {
  globalThis.sessionStorage.removeItem(postSignInRedirectStorageKey);

  return redirect({
    replace: true,
    search: {
      error,
      error_description: errorDescription,
      reason: 'login-failed',
    },
    to: '/unauthorized',
  });
}
